<script setup lang="ts">
import lodashPick from 'lodash-es/pick';

export interface StoryblokSectionProps {
    blok: StoryblokSection;
}

// PROPS
const { blok } = defineProps<StoryblokSectionProps>();

// COMPOSABLES
const { classes } = useStoryblokComponentClass(() => lodashPick(blok, ['anchorId']));
const { classes: bodyClasses } = useStoryblokComponentClass(() => lodashPick(blok, ['maxWidth', 'center']));
</script>

<template>
    <BaseWidthContainer :id="blok.anchorId" v-editable="blok" class="my-6 space-y-8 sm:my-8 xl:my-14" :class="classes">
        <h2 v-if="!!blok.title" class="text-primary-800 text-center text-3xl font-semibold sm:text-4xl">
            {{ blok.title }}
        </h2>
        <StoryblokRichTextOverride v-if="!!blok.description" :doc="blok.description" class="max-w-none" />
        <div v-if="blok.body?.length" class="space-y-8" :class="bodyClasses">
            <StoryblokComponent v-for="b in blok.body" :key="b._uid" :blok="b" />
        </div>
    </BaseWidthContainer>
</template>
